import { apiInterfaceForJson } from '../common/apiManager';
import { serviceConstants } from '../common/constants';
import { getUserAuthToken } from '../common/util';

// Search/list QC runs
export const searchQcRuns = (query = '', page = 1, limit = 25, sortField = 'runDate', sortOrder = 'desc', filters = {}) => {
    const params = new URLSearchParams();
    if (query) params.append('q', query);
    params.append('page', page);
    params.append('limit', limit);
    params.append('sortField', sortField);
    params.append('sortOrder', sortOrder);
    if (filters.instrument) params.append('instrument', filters.instrument);
    if (filters.analyte) params.append('analyte', filters.analyte);
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);
    return apiInterfaceForJson(`/qc-viewer/v1/runs?${params.toString()}`, 'GET');
};

// Get single QC run with all test results
export const getQcRun = (id) => {
    return apiInterfaceForJson(`/qc-viewer/v1/runs/${id}`, 'GET');
};

// Search/list QC samples
export const searchQcSamples = (query = '', page = 1, limit = 25, sortField = 'sampleName', sortOrder = 'asc') => {
    const params = new URLSearchParams();
    if (query) params.append('q', query);
    params.append('page', page);
    params.append('limit', limit);
    params.append('sortField', sortField);
    params.append('sortOrder', sortOrder);
    return apiInterfaceForJson(`/qc-viewer/v1/samples?${params.toString()}`, 'GET');
};

// Get single QC sample with ranges
export const getQcSample = (id) => {
    return apiInterfaceForJson(`/qc-viewer/v1/samples/${id}`, 'GET');
};

// Search/list QC reports
export const searchQcReports = (query = '', page = 1, limit = 25, sortField = 'startDate', sortOrder = 'desc') => {
    const params = new URLSearchParams();
    if (query) params.append('q', query);
    params.append('page', page);
    params.append('limit', limit);
    params.append('sortField', sortField);
    params.append('sortOrder', sortOrder);
    return apiInterfaceForJson(`/qc-viewer/v1/reports?${params.toString()}`, 'GET');
};

// Get single QC report
export const getQcReport = (id) => {
    return apiInterfaceForJson(`/qc-viewer/v1/reports/${id}`, 'GET');
};

// Get dashboard stats
export const getQcStats = () => {
    return apiInterfaceForJson('/qc-viewer/v1/stats', 'GET');
};

// Get filter options (instruments, analytes)
export const getQcFilterOptions = () => {
    return apiInterfaceForJson('/qc-viewer/v1/filters', 'GET');
};

// Construct URL for an L-J Report HTML file (served as static file by nginx)
export const getLjReportUrl = (filePath) => {
    return `/lj_reports/${encodeURI(filePath)}`;
};
